<template>
  <div>
    <h1 class="text-lg">Builder cache burst</h1>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: false
})
const runtimeConfig = useRuntimeConfig();
const builderApiKey = runtimeConfig.public.builderApiKey;
const builderStore = useBuilderStore();
const nuxtApp = useNuxtApp();
const i18n = useI18n();
const locale = i18n.locale;
const {defaultLocale} = i18n;

await useAsyncData(
    'ribbon-cache-burst',
    () => getRibbonData()
);

await useAsyncData(
    "header-links-cache-burst",
    () => getHeaderLinks()
);

await useAsyncData("footer-links-cache-burst",async () =>{
  const { getFooterLinks } = await import(
      "@/services-optimized/builderService"
      );
  return getFooterLinks(builderApiKey, {locale: i18n.defaultLocale},nuxtApp,true)
});


// Use a function to get ribbon data to avoid memory leaks
async function getRibbonData() {
  return builderStore.getList('ribbon',{},{},100,0,nuxtApp,true)
}


async function getHeaderLinks() {

  try {
    const {getHeaderMenu} = await import("~/services-optimized/builderService");

    return getHeaderMenu(defaultLocale, builderApiKey, nuxtApp,true);
  } catch (error) {
    return [];
  }
}

</script>